import { render, staticRenderFns } from "./modalActivarTienda.vue?vue&type=template&id=27d6babc"
import script from "./modalActivarTienda.vue?vue&type=script&lang=js"
export * from "./modalActivarTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports